import {
  getCountries,
  getStates,
  getPayoutMethods,
  getPendingPayouts,
  getCryptoCurrencyPayoutVerificationCode,
  postCryptoPayout,
  getPayoutBankAccounts,
  postWireTransferPayout,
} from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '@/utils/i18n';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

const state = {
  selectedWireTransfer: {
    id: 0,
  },
  bankAccounts: [],
  country: '',
  currentState: '',
  countries: [],
  states: [],
  isNewAccount: false,
  isIntermediated: false,
  account_bank_wire_id: -1,
  cod_transaction: '',
  file: '',
  IBAN: '',
  Comments: '',
  Bank_Zip: '',
  Bank_Name: '',
  Bank_city: '',
  Bank_Code: '',
  Bank_Phone: '',
  Bank_country: '',
  Bank_state: '',
  Name_Account: '',
  Routing_Code: '',
  Bank_Country: '',
  Account_Type: '',
  SWIF_BIC_Code: '',
  Account_Number: '',
  Bank_Sort_Code: '',
  Beneficiary_Name: '',
  account_echeck_id: '',
  Intermediated_IBAN: '',
  Bank_street_address: '',
  online_banking_card_id: '',
  Intermediated_Bank_Zip: '',
  Intermediated_Bank_Name: '',
  Intermediated_Bank_City: '',
  Intermediated_Bank_Code: '',
  Intermediated_Bank_State: '',
  Intermediated_Bank_Phone: '',
  Intermediated_Bank_Address: '',
  Intermediated_SWIF_BIC_Code: '',
  Intermediated_Account_Number: '',
  Intermediated_Bank_Sort_Code: '',

  walletName: '',
  walletAddress: '',
  verificationCode: '',
  verificationCodeModel: {},
  phoneNumber: '',
  verificationCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
  payoutCompleteCodeStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setIsBankAccount(state, val) {
    // if (!val) {
    //   state.account_bank_wire_id = null;
    // }
    state.isNewAccount = val;
  },
  unSet(state, val) {
    // if (!val) {
    //   state.account_bank_wire_id = null;
    // }
    state.isNewAccount = val;
  },
  setIntermediated(state) {
    state.isIntermediated = !state.isIntermediated;
  },
  setVerificationCodeModel(state, val) {
    state.verificationCodeModel = val;
  },
  setVerificationCodeStatus(state, row) {
    state.verificationCodeStatus = {
      ...state.verificationCodeStatus,
      ...row,
    };
  },
  setPayoutCompleteCodeStatus(state, row) {
    state.payoutCompleteCodeStatus = {
      ...state.payoutCompleteCodeStatus,
      ...row,
    };
  },
  setCountries(state, cols) {
    state.countries = cols;
  },
  setStates(state, cols) {
    state.states = cols;
  },
  setPayoutBankAccounts(state, cols) {
    state.bankAccounts = cols;
  },
  setCodTransaction(state, val) {
    state.cod_transaction = val;
  },
  setSelectedWireTransfer(state, wire) {
    state.selectedWireTransfer.id = wire.id;
  },
  resetSelectedWireTransfer(state, rootState) {
    state.selectedWireTransfer.id = 0;
  },
};

const actions = {
  tryGetCountries({ commit, rootState }) {
    getCountries(rootState.settings.brandSettings.book_id, rootState.settings.selectedLocale.short_code).then(r => {
      if (r.data.IsSuccess) {
        commit('setCountries', r.data.Data);
      }
    });
  },
  tryGetStates({ commit }, iso2) {
    if (iso2)
      getStates(iso2).then(r => {
        if (r.data.IsSuccess) {
          commit('setStates', r.data.Data);
        }
      });
  },
  tryGetPayoutBankAccounts({ commit }) {
    const method = 'bankwire';
    getPayoutBankAccounts(method).then(r => {
      if (r.data.IsSuccess) {
        commit('setPayoutBankAccounts', r.data.Data.data);
      }
    });
  },
  tryPostWireTransferPayout({ commit, dispatch }, formData) {
    commit('setPayoutCompleteCodeStatus', { loading: true });
    commit('setPayoutCompleteCodeStatus', {});
    postWireTransferPayout(formData).then(r => {
      if (r.data.IsSuccess) {
        if (r.data.Data.status === 'OK') {
          dispatch('payoutStore/tryGetPendingPayouts', null, { root: true });
          commit('setCodTransaction', r.data.Data.payout.cod_transaction);
          commit('setPayoutCompleteCodeStatus', {
            success: true,
            error: false,
          });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: i18n.t('Exceptions.' + r.data.Data.error_code || r.data.Data.message),
          });
        }
      } else {
        if (r.data.ExceptionMessage[0] === 'ROLLOVER_REACHED') {
          commit('payoutStore/setRollover', { error: true }, { root: true });
        } else {
          commit('setPayoutCompleteCodeStatus', {
            success: false,
            error: r.data.ExceptionMessage[0],
          });
        }
      }
      commit('setPayoutCompleteCodeStatus', { loading: false });
      dispatch('player/tryGetBalance', null, { root: true });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

/*

BANK ACCOUNT MODEL
{
      "id": 1,
      "account_type": "C",
      "active": true,
      "bank_account_number": "273737373733737",
      "bank_country": "Te",
      "bank_international_account_number": "636262",
      "bank_name": "Test ",
      "bank_street_address": null,
      "bank_state": null,
      "bank_city": null,
      "bank_zip": null,
      "bank_phone_number": "98682876",
      "bank_route_code": "63626",
      "bank_sort_code": "636366",
      "bank_swift_code": "",
      "customer_account": "MB143913",
      "name_on_account": null,
      "is_default": false,
      "is_approved": false,
      "created_at": "2018-08-15 15:28:50",
      "deleted_at": null,
      "updated_at": "2018-08-15 15:28:50",
      "created_by": "MB143913",
      "deleted_by": null,
      "updated_by": null,
      "bank_intermediaries": []
  }

*/
